import { render } from "./SupplierCreateComponent.vue?vue&type=template&id=15670be3"
import script from "./SupplierCreateComponent.vue?vue&type=script&lang=js"
export * from "./SupplierCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Supplier/SupplierCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15670be3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15670be3', __exports__)) {
    api.reload('15670be3', __exports__)
  }
  
  module.hot.accept("./SupplierCreateComponent.vue?vue&type=template&id=15670be3", () => {
    api.rerender('15670be3', render)
  })

}


export default __exports__